import { useSelector, useDispatch } from "react-redux";
import {
  useGetAiOrdersListDataQuery,
  useUpdateAiOrdersTableHeadDataMutation,
} from "../../../store/queries/Admin";
import { updateConfig } from "../../../store/slices/Admin/AiOrders/aiOrdersSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useState } from "react";
import { subDays } from "date-fns";
import { getFormatedDate } from "../../../utils/Functions/table";
import { toast } from "react-toastify";
import { getExportedData } from "./api";

const useAiOrderList = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];

  const dispatch = useDispatch();
  const [isDateRangeApplied, setIsDateRangeApplied] = useState(false);
  const [isExcelLinkSend, setIsExcelLinkSend] = useState(false);
  const aiordersState = useSelector((state) => state.aiorders);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const {
    data: aiOrdersList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetAiOrdersListDataQuery({
    per_page: aiordersState?.currentPageSize,
    page: aiordersState?.currentPage,
    sort: aiordersState?.sortBy,
    sort_order: aiordersState?.sortOrder,
    start_date: getFormatedDate(aiordersState?.startDate),
    end_date: getFormatedDate(aiordersState?.endDate),
    search: aiordersState?.search,
    store_name: aiordersState?.store_name,
    payment_mode: aiordersState?.payment_mode,
    status: aiordersState?.status,
    offer: aiordersState?.offer,
  });

  const [updateOrdersFields] = useUpdateAiOrdersTableHeadDataMutation();

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  useEffect(() => {
    if (aiOrdersList && aiOrdersList?.data?.total_count) {
      dispatch(
        updateConfig((state) => {
          state.totalOrderCount = aiOrdersList?.data?.total_count ?? "0";
        })
      );
    }
    //eslint-disable-next-line
  }, [aiOrdersList?.data?.total_count, aiOrdersList?.data?.total_amount]);

  const handleClearClick = () => {
    setDate({
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    });
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.currentPageSize = 10;
        state.startDate = subDays(new Date(), 30);
        state.endDate = new Date();
        state.sortBy = "";
        state.sortOrder = "";
        state.search = "";
        state.showCreateModal = false;
      })
    );
    setIsDateRangeApplied(false);
  };

  const handleSort = (label) => {
    if (aiordersState?.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = aiordersState?.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      posist_status: (field, data) =>
        data?.posist_status === "Preparing" ? (
          <span className={"pro-badge badge-grey-outline"}>{"Preparing"}</span>
        ) : data?.posist_status === "Pending" ? (
          <span className={"pro-badge badge-warning-outline"}>{"Pending"}</span>
        ) : data?.posist_status === "Delivered" ? (
          <span className={"pro-badge badge-success-outline"}>
            {"Delivered"}
          </span>
        ) : data?.posist_status === "Food prepared" ? (
          <span className={"pro-badge badge-primary-outline"}>
            {"Food prepared"}
          </span>
        ) : data?.posist_status === "Failed" ? (
          <span className={"pro-badge badge-danger-outline"}>{"Failed"}</span>
        ) : data?.posist_status === "Waiting for pickup" ? (
          <span className={"pro-badge badge-waiting-outline"}>
            {"Waiting for pickup"}
          </span>
        ) : data?.posist_status === "Processing" ? (
          <span className={"pro-badge badge-processing-outline"}>
            {"Processing"}
          </span>
        ) : (
          <span className={"pro-badge badge-grey-outline"}>
            {data?.posist_status}
          </span>
        ),

      chat_session_id: (field, data) => (
        data?.chat_session_id ? (
          <div className="col-auto">
            <button
              className="pro-badge badge-primary-outline rounded-pill px-3 py-1 d-flex align-items-center gap-1 shadow-sm pro-d-flex pro-gap-1"
              onClick={() => handleChatAction(data)}
            >
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                chat_bubble
              </span>
              <span>Chat Bot</span>
            </button>
          </div>
        ) : ""
      ),

    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const [date, setDate] = useState({
    startDate: aiordersState?.startDate,
    endDate: aiordersState?.endDate,
    key: "selection",
  });
  const handleDateChange = (range) => {
    setIsDateRangeApplied(true);
    setDate(range);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = range.startDate;
        state.endDate = range.endDate;
      })
    );
  };
  const handleDateRangeChange = (range) => {
    setIsDateRangeApplied(true);
    const startDate = range[0];
    const endDate = range[1];

    setDate({
      startDate,
      endDate,
    });

    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = startDate;
        state.endDate = endDate;
      })
    );
  };
  const handleExcelDownload = () => {
    dispatch(
      updateConfig((state) => {
        state.excelSendModal = !state.excelSendModal;
      })
    );
  };

  const modalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.excelSendModal = false;
      })
    );
  };
  const sendExcelData = async (value) => {
    setIsExcelLinkSend(true);
    let params = {
      start_date: getFormatedDate(aiordersState?.startDate),
      end_date: getFormatedDate(aiordersState?.endDate),
      sort_order: aiordersState?.sortOrder,
      sort: aiordersState?.sortBy,
      search: aiordersState?.search,
      store_name: aiordersState?.store_name ?? [],
      payment_mode: aiordersState?.payment_mode ?? [],
      status: aiordersState?.status ?? [],
      offer: aiordersState?.offer ?? [],
      email: value?.email ?? "",
      type: value?.type ?? "",
    };
    let response = await getExportedData(params);
    try {
      if (response?.status === 200) {
        toast.success(`Excel download link send successfully`);
      } else {
        toast.error(`Failed to send download link,Please try again`);
      }
    } catch (error) {
      console.error("Failed to send link:", error);
      toast.error(`Failed to send download link`);
    } finally {
      modalClose();
      setIsExcelLinkSend(false);
    }
  };
  const handleFilterAction = () => {
    dispatch(
      updateConfig((state) => {
        state.filterShow = !state.filterShow;
      })
    );
  };
  const handleChatAction = (data) => {
    dispatch(
      updateConfig((state) => {
        state.chatShow = !state.chatShow;
        if (data) {
          state.mobile = data?.user_id;
          state.chatSectionId = data?.chat_session_id;
          state.userName = data?.user_name;
        }
      })
    );
  };

  return {
    date,
    isLoading,
    isFetching,
    aiOrdersList,
    tableFields,
    aiordersState,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    isDateRangeApplied,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleExcelDownload,
    handleFilterAction,
    handleChatAction,
    updateOrdersFields,
    handlePagination,
    handleClearClick,
    handleDateChange,
    handlePageSize,
    sendExcelData,
    handleSearch,
    handleSort,
    modalClose,
    refetch,
    getRow,
  };
};

export default useAiOrderList;
